export default class Cookie {

    buildUrl() {
        let parts = [];
        for (let i = 0; i < this.selects.length; i++) {
            let select = this.selects[i];
            let partIndex = select.getAttribute('data-url-index');

            parts[partIndex] = select.options[select.selectedIndex].value.replace(/\/$/g, '');
        }

        return parts.join('/') + '/';
    }

    setCookie(name,value,seconds) {
        var expires = "";
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds*1000));
            console.log(date.toUTCString());
            expires = "; expires=" + date.toGMTString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    eraseCookie(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}